<template>
    <div class="main-wrapper">
        <div class="community-wrapper">
            <div class="community-comments">
                <h1>Our Community
                    <br class="d-block d-sm-none">
                    Makes Us Blush</h1>
                <div class="comments-panel swiper-container" ref="swiperContainer">
                    <div class="swiper-wrapper">
                        <div
                            v-for="comment in allComments"
                            :key="comment.id"
                            class="swiper-slide comment">
                            <div class="comment-text">
                                <p>{{comment.text}}</p>
                            </div>
                            <div class="d-flex align-items-center profile">
                                <div class="profile-picture">
                                    <img :src="'/img/' + comment.image">
                                </div>
                                <div class="profile-text">
                                    <div class="name">{{comment.name}}</div>
                                    <div class="role">{{comment.role}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="swiper-pagination"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Swiper from 'swiper';
export default {
    data() {
        return {
            allComments: [
                {
                    id: '0',
                    text:
                        '“5 minutes into using the Beta update and it’s like I’m using a whole new platform. Superb improvements over the last version. The customizability to this is great. Cant’ wait to see the mobile app early next year!”',
                    image: 'michael.png',
                    name: 'Michael Tobin',
                    role: 'Owner/CEO at Initial Focus Media'
                },
                {
                    id: '1',
                    text:
                        '"Currently using various applications to maintain some semblance of order, however from what I see here this will give me the perfect "user friendly experience" I really need! Can\'t wait to sample!"',
                    image: 'juan.png',
                    name: 'Juan Cano Diaz',
                    role: 'Vice President at Clúster Marítimo Español'
                },

                {
                    id: '2',
                    text:
                        '"Finally got into Beta of Infinity - a rock\'n\'roll pm tool all of you folks should try. Hopefully leaving Trello behind."',
                    image: 'damir.png',
                    name: 'Damir Francišković',
                    role: 'Owner of Compito'
                },
                {
                    id: '3',
                    text:
                        '"The original beta version of Infinity was groundbreaking. The update is game-changing! It is an incredibly flexible and unique productivity tool with unbelievable capabilities and a beautiful UI. Dashboards, tabs, views, galleries, and more. Absolutely love it!"',
                    image: 'just.jpg',
                    name: 'Just Sturgis',
                    role: 'Founder of Simple Lotus'
                },
                {
                    id: '4',
                    text:
                        '"What makes Infinity great is not only the number of features but the people who stand behind its development. The team creating Infinity is infinitely responding to all user voices, which makes the present and the future of this platform both bold and bright."',
                    image: 'michal.jpg',
                    name: 'Michał A. Nowakowski',
                    role: 'Owner of CJO EFFEKT'
                },
                {
                    id: '5',
                    text:
                        '"The tool is really comfortable to use. Since the first time, Infinity became the part of my daily management. Day by day it makes organizing easier. Excited to see the full bright of the app. I’d rate it 10/10."',
                    image: 'emir.jpg',
                    name: 'Emir Košpo',
                    role: 'Web developer at First Contact'
                },
                {
                    id: '6',
                    text:
                        '“I use Infinity to organize my agency. From employee and client onboarding to task and project management, its versatility saves me hundreds each month in fees I would otherwise be paying for various SaaS products.”',
                    image: 'mich.png',
                    name: 'Micheal Pacheco',
                    role: 'Founder of Boxer.'
                }
            ],
            counter: 0,
            showComment: true,
            swiper: null
        };
    },
    mounted() {
        this.swiper = new Swiper(this.$refs.swiperContainer, {
            slidesPerView: 'auto',
            spaceBetween: 60,
            centeredSlides: true,
            loop: true,
            pagination: {
                el: '.swiper-pagination',
                clickable: true
            }
        });
    },
    destroyed() {
        this.swiper.destroy();
        this.swiper = null;
    }
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}
.community-wrapper {
    margin-top: 40px;
    padding: 0;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
}
.community-comments {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    flex-wrap: wrap;
}
.comment-text {
    min-height: 144px;
}
.comments-panel {
    margin-bottom: 30px;
    min-height: 350px;
}
@media (min-width: 577px) {
    .profile-text {
        margin-left: 12px;
    }
}
@media (max-width: 576px) {
    .profile {
        flex-direction: column;
        text-align: center;
    }
}

h1 {
    font-size: 36px;
    line-height: 48px;
    margin-bottom: 45px;
    font-weight:600;

}
@media (max-width: 961px) {
    h1 {
        text-align: center;
        font-size: 32px;
    }
    .comments p {
        font-size: 16px;
    }
}
.swiper-wrapper {
    margin-top: 30px;
}
.comment {
    border-radius: 10px;
    background-color: #fff;
    box-shadow: 0 0 30px 0 rgba(0, 0, 0, 0.2);
    padding: 30px;
    height: auto;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 30vw;
}

@media (min-width: 768px) and (max-width: 992px) {
    .comment {
        width: 50vw;
    }
}
@media (max-width: 768px) {
    .comment {
        width: 90vw;
    }
}
.name {
    font-size: 18px;
    line-height: 22px;
    font-weight: 600;
}
p {
    font-size: 18px;
    line-height: 22px;
    font-style: italic;
}
.profile-picture {
    width: 45px;
    height: 45px;
    display: inline-block;
}
img {
    width: 100%;
    border-radius: 50%;
}
.ic-arrow-left {
    border: none;
    font-size: 44px;
    color: #8f90a1;
    cursor: pointer;
    background: transparent;
}
@media (max-width: 1000px) {
    .ic-arrow-left {
        left: -50px;
    }
}
@media (max-width: 1000px) {
    .ic-arrow-right {
        right: -50px;
    }
}
@media (max-width: 660px) {
    .ic-arrow-left {
        left: 0px;
    }
    .ic-arrow-right {
        right: 0px;
    }
    .comments p {
        padding-left: 50px;
        padding-right: 50px;
    }
}
.ic-arrow-left:focus {
    outline: none;
}
.ic-arrow-right {
    border: none;
    font-size: 44px;
    color: #8f90a1;
    cursor: pointer;
    background: transparent;
}
.ic-arrow-right:focus {
    outline: none;
}

.ic-favorites {
    color: #1ba7e0;
    padding-right: 5px;
    font-size: 16px;
}
.stars {
    margin-bottom: 20px;
}
.role {
    color: #8f90a1;
    font-size: 18px;
    line-height: 22px;
}
</style>

<style>
.swiper-pagination-bullet-active {
    background: #FFF;

}
.swiper-pagination-bullet{
    width:10px;
    height:10px;
}
.swiper-container-horizontal>.swiper-pagination-bullets .swiper-pagination-bullet{
    margin:0 5px;
}
</style>



// WEBPACK FOOTER //
// resources/js/frontend/components/CommentSlider.vue